import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Card, CardContent, Grid, Paper } from "@material-ui/core";
import { renderTextField } from "../../form-global-components/components-form-components-for-react-final-form";
class FormFieldsTabAddress extends Component {
  render() {
    return (
      <div>
        <Paper>
          <Card>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id="street"
                    name="street"
                    label="Street Address"
                    emptyText="Street Address"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id="city"
                    name="city"
                    label="City"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id="state"
                    name="state"
                    label="State"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id="zip"
                    name="zip"
                    label="Zip"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id="phonenumber"
                    name="phonenumber"
                    label="Phone Number"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id="emergencycontact"
                    name="emergencycontact"
                    label="Emergency Contact"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id="emergencycontactnumber"
                    name="emergencycontactnumber"
                    label="Emergency Contact Number"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Paper>
      </div>
    );
  }
}
FormFieldsTabAddress.propTypes = {
  locked: PropTypes.bool,
};
export default FormFieldsTabAddress;
